// extracted by mini-css-extract-plugin
export default {"side-panel-content":"SidePanelContent_side-panel-content__dHvXl","side-panel-content--active":"SidePanelContent_side-panel-content--active__Mxfvp"};